import { Group } from "@mantine/core"
import { IconSearch } from "@tabler/icons-react"
import { Select, TextInput } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { useFiltersSelectProps } from "~/pages/Brand/Certificates/hooks/useFiltersSelectProps"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesFilters = () => {
  const { t } = useTranslation(["certificates", "common"])

  const filtersSelectsProps = useFiltersSelectProps()

  const { filters, setGlobalFilter, globalFilter } =
    useCertificatesTableContext()

  return (
    <Group>
      <TextInput
        size="xs"
        autoFocus
        maw={200}
        placeholder={t("lists.placeholders.search")}
        onChange={(e) => setGlobalFilter(e.target.value)}
        leftSection={<IconSearch size={16} />}
        style={{ flexGrow: 1 }}
        value={globalFilter}
      />
      {filtersSelectsProps.map((selectProps) =>
        !selectProps.hidden ? (
          <Select
            size="xs"
            key={selectProps.key}
            data={selectProps.data}
            placeholder={selectProps.placeholder}
            onChange={selectProps.onChange}
            value={selectProps.getValue(filters)}
            onClear={selectProps.onClear}
            clearable
          />
        ) : null
      )}
    </Group>
  )
}
